import _ from "lodash";

export const formatNumber = (num?: number, separator?: string) => {
  const numCast = _.toNumber(num);
  if (!_.isFinite(numCast) || _.isNaN(numCast) || !_.isNumber(numCast)) {
    return "";
  }

  return numCast.toString().replace(/^[+-]?\d+/, function (int) {
    // eslint-disable-next-line sonarjs/slow-regex -- legacy warning, to review
    return int.replace(/(\d)(?=(\d{3})+$)/g, `$1${separator}`);
  });
  // explanations here https://stackoverflow.com/a/58436483/6627882
  // return numCast.toString().replace(/^[+-]?\d+/, function (int) {
  //   return int.replace(/(\d)(?=(\d{3})+$)/g, "$1 ");
  // });
};

export function toFixedNumber(num: number, digits: number, base: number) {
  const pow = Math.pow(base ?? 10, digits);
  return Math.round(num * pow) / pow;
}

export const roundToNearestHalf = (num: number) => Math.round(num * 2) / 2;
